:host{display:flex;justify-content:space-between;align-items:center}.value-and-reset{display:flex;align-items:center}.reset-button{border:none;border-radius:100%;color:#5a42d0}.setting-label,.value-label{color:#232426de}
/*# sourceMappingURL=settings-header.component.css.map */
